import { useApi } from '@api/ApiProvider'
import { useI18n } from '@i18n/I18nProvider'
import { ErrorState, LoadingState } from '@ui/States'
import { ConditionFilter } from './ConditionFilter'
import { usePanelFilters } from './filters'
import { Pager } from './Pager'
import { ReportCard } from './ReportCard'
import { usePanelQuery } from './StaffSession'
import { PAGE_SIZE } from './TreesPage'
import { useNames } from './useNames'

// Pestaña "Avisos": los avisos de los caminantes, del más reciente al más antiguo, con su foto.
export const ReportsPage = () => {
	const { t } = useI18n()
	const api = useApi()
	const names = useNames()
	const { condition, page, setCondition, setPage } = usePanelFilters()
	const reports = usePanelQuery(['reports', condition ?? 'all', page], (token) =>
		api.reports(token, { condition, page, limit: PAGE_SIZE })
	)

	return (
		<>
			<ConditionFilter value={condition} onChange={setCondition} />
			{reports.isPending ? (
				<LoadingState shape="list" />
			) : !reports.data ? (
				<ErrorState error={reports.error} onRetry={() => reports.refetch()} />
			) : reports.data.items.length === 0 ? (
				<p className="py-8 text-center text-lg text-earth-800">{t('reports.empty')}</p>
			) : (
				<>
					<p className="mb-3 text-earth-800">{t('reports.count', { count: reports.data.meta.total })}</p>
					<ul className="grid gap-3">
						{reports.data.items.map((report) => (
							<li key={report.id}>
								<ReportCard report={report} municipality={names.municipality(report.municipalityId)} />
							</li>
						))}
					</ul>
					<Pager meta={reports.data.meta} onChange={setPage} />
				</>
			)}
		</>
	)
}
